import settings from '../config/settings';
import fetchApiWrapper from './fetchApiWrapper';
export type { ApiError } from './errors';
export { ApiErrorCode } from './errors';

export const resendVerificationEmail = (email: string, password: string, clientId: string, language: string) => {
  const requestHeaders = new Headers();
  requestHeaders.set('Content-Type', 'application/json-patch+json; charset=utf-8');

  return fetchApiWrapper(`${settings.backend.endpoint}/verification-email?version=v2`, {
    body: JSON.stringify({ email, password, client_id: clientId, language }),
    headers: requestHeaders,
    method: 'POST',
  })
}

export const sendWelcomeEmail = (email: string, language: string, token: string) => {
  const requestHeaders = new Headers();
  requestHeaders.set('Content-Type', 'application/json-patch+json; charset=utf-8');
  requestHeaders.append('Authorization', `BEARER ${token}`)

  return fetchApiWrapper(`${settings.backend.endpoint}/post-password-change-emails`, {
    body: JSON.stringify({ email, language }),
    headers: requestHeaders,
    method: 'POST',
  })
}

export const validateEmailChangeToken = (token: string): Promise<boolean> => {
  const headers = new Headers({
    'Content-Type': 'application/json-patch+json; charset=utf-8',
    'Authorization': `BEARER ${token}`
  });

  return fetchApiWrapper(`${settings.backend.endpoint}/email-changes/validation`, {
    method: 'POST',
    headers,
  }).then(() => true).catch(() => false);
}

export const confirmEmailChange = (token: string, password: string): Promise<void> => {
  const headers = new Headers({
    'Content-Type': 'application/json-patch+json; charset=utf-8',
    'Authorization': `BEARER ${token}`
  });

  return fetchApiWrapper(`${settings.backend.endpoint}/users/me/email`, {
    method: 'PUT',
    headers,
    body: JSON.stringify({ password }),
  });
}

export const requestEmailChange = (language: string, token: string): Promise<void> => {
  const headers = new Headers({
    'Content-Type': 'application/json-patch+json; charset=utf-8',
    'Authorization': `BEARER ${token}`,
  });

  return fetchApiWrapper(`${settings.backend.endpoint}/users/me/email-changes`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ language }),
  });
};

export const submitNewEmail = (newEmail: string, language: string, token: string): Promise<void> => {
  const headers = new Headers({
    'Content-Type': 'application/json-patch+json; charset=utf-8',
    'Authorization': `BEARER ${token}`,
  });

  return fetchApiWrapper(`${settings.backend.endpoint}/users/me/email-changes/new-email`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ new_email: newEmail, language }),
  });
};
